import { UserConnectedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('userConnectedLeaders');
export const findByIdThrows = createFindByIdThrows('userConnectedLeaders');

type GetFulfilledUserConnectedLeaders = (state: YammerState) => Record<string, UserConnectedLeader>;
export const getFulfilledUserConnectedLeaders: GetFulfilledUserConnectedLeaders = (state) =>
  state.userConnectedLeaders.fulfilled.byId;
